/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Plus } from 'lucide-react';

function TabPageHeader({ title, subtitle, buttonName, onClickBtn }) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between px-4 pt-4 pb-3">
      <div className="min-w-0">
        <h4 className="text-base font-semibold text-ink-900 mb-0.5">{title}</h4>
        <p className="text-sm text-ink-500">{subtitle}</p>
      </div>
      {buttonName && (
        <button
          type="button"
          onClick={() => onClickBtn()}
          className="inline-flex items-center gap-1.5 box-border h-10 px-4 rounded-[8px] text-sm font-semibold text-white bg-brand-700 hover:bg-[#1a3156] transition flex-shrink-0"
        >
          <Plus size={16} />
          {buttonName}
        </button>
      )}
    </div>
  );
}

TabPageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  buttonName: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  onClickBtn: PropTypes.func,
};

TabPageHeader.defaultProps = { buttonName: null, onClickBtn: () => {} };

export default TabPageHeader;
